import styled from 'styled-components';

export const LoginHead = styled.h1`
  font-size: 30px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.87);
  font-family: Montserrat;
  padding: 12% 0% 4% 8%;
  @media (max-width: 720px) {
    padding: 52px 25px 0;
  }
`;
export const LoginForm = styled.div`
  padding: 15% 8%;
  color: rgba(0, 0, 0, 0.68);
  #kwikpass-sso-container button {
    width: 100%;
    height: 56px;
    flex-grow: 0;
    margin: 36px 0px 28px;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #3a4796;
    font-family: Montserrat;
    font-weight: 600;
  }
  @media (max-width: 720px) {
    padding: 40px 25px 0;
  }
`;
export const NewLoginContainer = styled.div`
  width: ${(props) => (props.loggedIn ? '100%' : '50%')};
  margin: auto;
  z-index: ${(props) => (props.loggedIn ? '99999' : '')};
  position: ${(props) => (props.loggedIn ? 'absolute' : '')};
  background: ${(props) => (props.loggedIn ? '#fff' : '')};
  height: 100%;

  .mobile-only {
    display: none;
    width: 100%;
  }

  @media (max-width: 720px) {
    width: 100%;

    .mobile-only {
      display: block;
    }
  }
  .cross_icon {
    top: 5%;
    position: absolute;
    right: 5%;
    cursor: pointer;
    @media (max-width: 720px) {
      display: none;
    }
  }
`;

export const LoginDesc = styled.p`
  font-size: 18px;
  color: #000;
  color: rgba(0, 0, 0, 0.68);
  padding: 36px 0 25px;
  display: flex;
  gap: 20px;
  align-items: baseline;
  padding: 0% 0% 0% 10%;
  img {
    width: 14px;
    height: 14px;
    &.lowOpacity {
      opacity: 0.4;
    }
  }
  @media (max-width: 720px) {
    padding: 30px 25px 0;
  }
`;
export const GetOtpContainer = styled.div`
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    top: 50%;
  }
`;
export const ButtonContainer = styled.button`
  position: relative;
  width: ${(props) => (props.fromConsult ? '15%' : '100%')};
  background-color: ${(props) =>
    props.disableSendButton ? '#e0e0e0' : '#ef4e5e'};
  color: ${(props) =>
    props.disableSendButton ? 'rgba(0, 0, 0, 0.26)' : 'rgba(255,255,255)'};
  border: none;
  outline: none;
  text-align: center;
  margin-top: ${(props) => (props.fromConsult ? '5%' : '10%')};
  height: 56px;
  line-height: 42px;
  font-size: 16px;
  font-weight: 900;
  overflow: hidden;
  cursor: pointer;
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  @media (max-width: 720px) {
    cursor: none;
    margin-top: 30px;
    width: ${(props) => (props.fromConsult ? '90%' : '100%')};
  }
`;
export const ImageContainer = styled.div`
  display: none;
  @media (max-width: 720px) {
    width: 40%;
    position: absolute;
    left: 60%;
    bottom: 0px;
    margin-bottom: 13px;
  }
`;
export const ResendOtp = styled.p`
  font-size: 13px;
  text-align: center;
  padding-top: 28px;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  justify-content: center;
`;
export const ErrorMsg = styled.p`
  font-size: 13px;
  padding-top: 15px;
  text-align: left;
  color: #ef4e5e;
`;
export const ResentOtpButton = styled.p`
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: #ef4e5e;
  padding-top: 9px;
  cursor: pointer;
  &.lowOpacity2 {
    opacity: 0.4;
  }
  @media (max-width: 720px) {
    cursor: none;
  }
`;
export const InputWrapper = styled.div`
  position: relative;
  display: grid;
`;

export const GuestCheckoutContainer = styled.div`
  p {
    font-size: clamp(14px, 2vw, 16px);
    padding: ${(props) => (props.discountOnMRP ? '12px 22px 0' : '12px 22px')};
    font-weight: 500;
    text-align: left;
  }
  .price {
    font-size: 22px;
    font-weight: 600;
    text-align: left;
    color: #60afa5;
    padding: 8px 22px 12px;
  }
`;
export const GuestCheckoutBtn = styled.button`
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  background-color: #ef4e5e;
  font-family: 'Montserrat';
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 500;
  flex-basis: 50%;
  padding: 12px 0;
  @media (min-width: 768px) {
    cursor: pointer;
  }
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
export const GradientHead = styled.h3`
  background-image: linear-gradient(to right, #60afa5 0%, #8ccda8 100%);
  font-size: clamp(16px, 3vw, 18px);
  font-weight: 600;
  padding: 14px;
  color: #fff;
  text-align: left;
  border-radius: 8px 8px 0px 0px;
  margin: -1px;
`;
export const RedirectingStyle = styled.div`
  padding-top: 20px;
  text-align: center;
  p {
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
  }
  img {
    @media (max-width: 720px) {
      width: 100%;
    }
  }
`;

export const SkipButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  cursor: pointer;
  p {
    font-size: 13px;
    font-weight: 500;
    color: #6e6e6e;
  }
  img {
    width: 12px;
    rotate: 270deg;
    opacity: 0.5;
    margin-left: 2px;
  }
  &.lowOpacity {
    opacity: 0.5;
  }
  @media (max-width: 720px) {
    position: absolute;
    top: 3.5%;
    right: 5%;
    padding-top: 0;
    cursor: none;
  }
`;

export const GuestButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-around;
  padding: 22px 8px;
`;
export const GuestGoBack = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  padding: 12px 0;
  font-weight: 500;
  flex-basis: 50%;
  font-size: 14px;
  color: #ef4e5e;
  @media (min-width: 768px) {
    cursor: pointer;
  }
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(0, 0, 0, 0.2);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
